import { Flex, Progress } from 'front-commons/ds';
import { SourceCardProps } from '../../interfaces';
import { Container, Content, Item, Trigger } from './styles';
import ProductCard from '../ProductCard';
import { buPrefix } from 'shared/product';
import { Typography as TypografyDS, Icon } from 'hype-ds';

export default function SourceCard({
	data,
	posId,
	openByDefault,
	loadingBasketType,
	deletingProductId,
	hasEditBasketPermission,
	handleOpenDialog,
	handleOpenDrawer,
	handleRemoveFromBasket,
}: SourceCardProps) {
	const sourceName = buPrefix(data?.businessUnitName) || data.industryName!;
	const reachedMinValue = data.diffToMinimum <= 0;
	const currentValue = data.minimumValueForSale - data.diffToMinimum;
	const percent = ((currentValue / data.minimumValueForSale) * 100).toFixed(2);
	return (
		<Container
			backgroundColor="--surface-white"
			padding="16px 16px 24px"
			defaultValue={openByDefault ? [String(data.id)] : []}
		>
			<Item key={String(data.id)} value={data.id} direction="column" gap="0" width="100%">
				<Trigger padding="0" cursor="pointer" width="100%" justifyContent="space-between" alignItems="center" gap="8px">
					<Flex direction="column" gap="4px" width="100%">
						<Flex
							alignItems={{ small: 'flex-start', medium: 'center' }}
							justifyContent="space-between"
							gap="0"
							direction={{ small: reachedMinValue ? 'row' : 'column', medium: 'row' }}
						>
							<TypografyDS.Label.S color="--text-primary">{sourceName}</TypografyDS.Label.S>
							<TypografyDS.Paragraph.XS color={reachedMinValue ? '--semantic-success-base' : '--text-primary'}>
								{reachedMinValue
									? 'Valor mínimo atingido'
									: `Faltam ${data.diffToMinimum.toCurrency()} para o valor mínimo`}
							</TypografyDS.Paragraph.XS>
						</Flex>
						<Progress
							height="2px"
							percent={Number(percent)}
							hiddenPercentage
							backgroundColor="--border-primary"
							predominantColor={reachedMinValue ? '--semantic-success-base' : '--semantic-info-text'}
						/>
					</Flex>

					<Icon name="expand_more" size="24px" color="--text-link" weight={500} />
				</Trigger>
				<Content padding="16px 0 0" direction="column" gap="24px">
					{data.products.map((product) => (
						<ProductCard
							key={product.id}
							data={product}
							posId={posId}
							sourceData={data}
							handleOpenDialog={handleOpenDialog}
							loadingBasketType={loadingBasketType}
							deletingProductId={deletingProductId}
							handleRemoveFromBasket={handleRemoveFromBasket}
							hasEditBasketPermission={hasEditBasketPermission}
						/>
					))}
				</Content>
			</Item>
		</Container>
	);
}
